export const Slider = ({ fill = '#001965' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 4.16667H17.5" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M2.5 4.16667H11.6667"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.33301 10.0007H17.4997"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M2.5 10.0007H5" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 15.8327H17.5" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M2.5 15.8327H11.6667"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.5122 2.98816C15.163 3.63903 15.163 4.69431 14.5122 5.34518C13.8613 5.99605 12.806 5.99605 12.1551 5.34518C11.5043 4.69431 11.5043 3.63903 12.1551 2.98816C12.806 2.33728 13.8613 2.33728 14.5122 2.98816"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.84518 8.82214C8.49605 9.47301 8.49605 10.5283 7.84518 11.1792C7.19431 11.83 6.13903 11.83 5.48816 11.1792C4.83728 10.5283 4.83728 9.47302 5.48816 8.82214C6.13903 8.17127 7.19431 8.17127 7.84518 8.82214"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.5122 14.6542C15.163 15.305 15.163 16.3603 14.5122 17.0112C13.8613 17.6621 12.806 17.6621 12.1551 17.0112C11.5043 16.3603 11.5043 15.305 12.1551 14.6542C12.806 14.0033 13.8613 14.0033 14.5122 14.6542"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
